import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { Icon } from '@/shared/ui/icon'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

type RecommendedButtonProps = {
  handleClick: () => void
}

function RecommendedButton(props: RecommendedButtonProps) {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.profile
  return (
    <AppButton
      variant="secondary"
      fullWidth
      onClick={props.handleClick}
      className={classes.root}
    >
      <div className={classes.content}>
        <Icon
          view="gamepad"
          width={36}
        />
        <p>{text.games4u}</p>
      </div>
      <div className={classes.content}>
        <Icon
          style={{
            marginTop: '6px',
          }}
          view="arrowRight"
          width={22}
        />
      </div>
    </AppButton>
  )
}

export default RecommendedButton
